var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideosvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-element": "frame",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 24,
    ry: 24,
    stroke: "none",
    fill: "#ed4444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    transform: "translate(4.800000000000001 4.800000000000001) scale(0.6)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6,2.2A1,1,0,0,0,6,3V21a1,1,0,0,0,1.6.8l12-9a1,1,0,0,0,0-1.6Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosvg);
export default __webpack_public_path__ + "static/media/videosvg.811d81cb37b653f02e04ae81bf446188.svg";
export { ForwardRef as ReactComponent };